module.exports = __webpack_public_path__ + "img/auth.ea3b94d.png";